<ul>
  <li *ngFor="let icon of iconList.icons">
    <sc-icon-picker-item (onSelected)="onIconSelected($event)"
      [icon]="icon">
    </sc-icon-picker-item>
  </li>
</ul>
